/**
 * Toggle search in header
 *
 * @return {void}
 */

const activeClass = 'is-active';
const searchBtnClass = '.js-btn-search';
const searchHolderClass = '.js-search-holder';

$(document).on('click', `${searchBtnClass}`, function(e) {
  e.preventDefault();
  $(searchHolderClass).toggleClass(activeClass);
});

$(document).on('click', function (e) {
  let target = $(e.target);

  if (!target.closest(`${searchBtnClass}, ${searchHolderClass}`).length) {
    $(searchHolderClass).removeClass(activeClass);
  }
});
